import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

import { useStore } from '../../store'
import { AVATAR_ACTIONS } from '../../store/avatar'

const useAvatar = () => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [avatarUrlLocalCopy, setAvatarUrlLocalCopy] = useState(null)

  const { state, dispatch } = useStore()

  const { avatarUrl, avatarExp } = state

  const commitToStore = (url) =>
    dispatch({
      type: AVATAR_ACTIONS.SET_AVATAR_URL,
      avatarUrl: url || avatarUrlLocalCopy,
    })

  const getAvatar = () => {
    if (avatarUrl && Date.now() < avatarExp) {
      return setAvatarUrlLocalCopy(avatarUrl)
    }

    return authedAxios
      .get('/api/image/avatar')
      .then((res) => {
        const url = res.data

        commitToStore(url)
        setAvatarUrlLocalCopy(url)
      })
      .catch((e) => {
        // console.error(e)
      })
  }

  const removeAvatar = () => {
    return authedAxios.delete('/api/image/avatar').then(() => commitToStore())
  }

  const saveAvatar = () => {
    if (avatarUrl && !avatarUrlLocalCopy && !selectedFile) return removeAvatar()
    if (avatarUrl && !selectedFile) return Promise.resolve()

    const formData = new FormData()
    formData.append('avatar', selectedFile)

    return authedAxios
      .put('/api/image/avatar', formData, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      })
      .then(() => {
        dispatch({
          type: AVATAR_ACTIONS.SET_AVATAR_URL,
          avatarUrl: avatarUrlLocalCopy,
        })
      })
  }

  const reset = () => {
    setAvatarUrlLocalCopy(avatarUrl)
    setSelectedFile(null)
  }

  useEffect(() => {
    getAvatar()
  }, [])

  return {
    storeAvatarUrl: avatarUrl,
    selectedFile,
    setSelectedFile,
    saveAvatar,
    getAvatar,
    avatarUrl: avatarUrlLocalCopy,
    setAvatarUrl: setAvatarUrlLocalCopy,
    reset,
  }
}

export default useAvatar
